import { format } from "date-fns";
import { Link } from "react-router-dom";
import { useDeleteBusinessdetailMutation } from '../businessdetailsApiSlice'


export default function BusinessdetailRow({ businessdetail }) {
    const [deleteBusinessdetail, { isLoading }] = useDeleteBusinessdetailMutation();

    const created = businessdetail.createdAt ? format(new Date(businessdetail.createdAt), "yyyy-MM-dd") : "—";

    const handleDelete = async () => {
        try {
            await deleteBusinessdetail({ id: businessdetail._id }).unwrap()
            alert(`Businessdetail '${businessdetail.title}' deleted successfully`)
        } catch (err) {
            console.error("Delete error:", err)
            alert(err?.data?.message || "Failed to delete businessdetail")
        }
    }

    return (
        <tr className="hover:bg-gray-50/40">
            <td className="px-6 py-3 text-sm text-gray-900 font-medium">{businessdetail.title}</td>
            <td className="px-6 py-3 text-sm text-gray-600">{businessdetail.shortTitle || "—"}</td>
            <td className="px-6 py-3 text-sm text-gray-600">{businessdetail.entrepreneur || "—"}</td>
            <td className="px-6 py-3 text-sm text-gray-600">{businessdetail.entrepreneurName || "—"}</td>
            {/* <td className="px-6 py-3 text-sm text-gray-600">
                {Array.isArray(businessdetail.roles) ? businessdetail.roles.map((r) => (
                <span key={r} className="mr-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-700 ring-1 ring-inset ring-gray-200">{r}</span>
                )) : businessdetail.roles || "—"}
            </td> */}
            <td className="px-6 py-3">
                {businessdetail.status === "open" ? (
                <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700 ring-1 ring-inset ring-emerald-200">
                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500"></span> open
                </span>
                ) : (
                <span className="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2.5 py-1 text-xs font-medium text-rose-700 ring-1 ring-inset ring-rose-200">
                    <span className="h-1.5 w-1.5 rounded-full bg-rose-500"></span> closed
                </span>
                )}
            </td>
            <td className="px-6 py-3 text-sm text-gray-600">{created}</td>
            <td className="px-6 py-3 text-right">
                <div className="inline-flex gap-2">
                <Link
                    to={`/dash/businessdetails/${businessdetail._id}`}  
                    className="rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
                >
                    Edit
                </Link>
                <button
                    onClick={handleDelete}
                    disabled={isLoading}
                    className="rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
                >
                    {isLoading ? "Deleting..." : "Delete"}
                </button>
                </div>
            </td>
        </tr>
    );
}
